export const TRANSLATIONS = {
    EN: {
        DASHBOARD_HEADER: {
            TITLE: 'My businesses',
        },
        DASHBOARD: {
            NEW: 'New',
            NEW_ORGANIZATION: 'Add new company',
            ORGANIZATION: 'Company',
            INCORPORATION: 'Incorporation',
            ORGANIZATIONS: 'Existing companies',
            CURRENT_VALUE: 'Current value',
            NOMINAL_VALUE: 'Nominal value',
            AMOUNT_SHARES: 'Number of shares',
            AMOUNT_SHAREHOLDERS: 'Number of shareholders',
            CURRENT_STATUS: 'Current status',
            COMPANY_NAME: 'Organization name',
            MANAGE_THIS_COMPANY: 'Manage this company',
            VIEW_DRAFT_DEED_AGREEMENT: 'View draft deed & agreement',
            PROCEED: 'Proceed',
            UNCONFIRMED: 'Unconfirmed',
            NO_ORGANIZATIONS: 'No organizations were found',
            IN_LIQUIDATION: 'In Liquidation',
            NEW_IN_LIQUIDATION: 'New liquidation',
            LIVE: 'Live',
            LIQUIDATING: 'Liquidating',
            ALL: 'All',
            REMOVE_INCORPORATION: 'Remove this incorporation',
            REMOVE: 'Remove',
            LIQUIDATION: 'Liquidation',
            CONVERT: 'Convert BV',
            TRANSFER: 'Transfer BV',
            UBO_CLIENT_DETAILS: 'UBO registration',
            GENERAL_CLIENT_DETAILS: 'General workflow',
        },
    },
    NL: {
        DASHBOARD_HEADER: {
            TITLE: 'Mijn ondernemingen',
        },
        DASHBOARD: {
            NEW: 'Nieuw',
            NEW_ORGANIZATION: 'Nieuwe onderneming toevoegen',
            ORGANIZATION: 'Onderneming',
            INCORPORATION: 'In oprichting',
            ORGANIZATIONS: 'Bestaande ondernemingen',
            CURRENT_VALUE: 'Huidige waarde',
            NOMINAL_VALUE: 'Nominale waarde',
            AMOUNT_SHARES: 'Aantal aandelen',
            AMOUNT_SHAREHOLDERS: 'Aantal aandeelhouders',
            CURRENT_STATUS: 'Huidige status',
            COMPANY_NAME: 'Naam onderneming',
            MANAGE_THIS_COMPANY: 'Manage deze onderneming',
            VIEW_DRAFT_DEED_AGREEMENT: 'Bekijk conceptakte & akkoord',
            PROCEED: 'Ga verder',
            UNCONFIRMED: 'Niet geverifiëerd',
            NO_ORGANIZATIONS: 'Er zijn geen organisaties gevonden',
            IN_LIQUIDATION: 'In Opheffing',
            NEW_IN_LIQUIDATION: 'Nieuwe opheffing',
            LIVE: 'Live',
            LIQUIDATING: 'Nieuwe Opheffing',
            ALL: 'Alles',
            REMOVE_INCORPORATION: 'Verwijder deze oprichting',
            REMOVE: 'Verwijder',
            LIQUIDATION: 'Opheffing',
            CONVERT: 'Omzetten BV',
            TRANSFER: 'Overdracht BV',
            UBO_CLIENT_DETAILS: 'UBO registratie',
            GENERAL_CLIENT_DETAILS: 'General workflow',
        },
    },
};
